import React from "react";
import { SkeletonBar } from "../../../components/Skeleton/Skeleton"; // pulls in the .cd-skl shimmer styles
import "./Insurance.css";

/*
  Page-specific loading skeleton for the Insurance screen. Self-contained
  (renders its own page shell + top bar) so it works BOTH as the route's
  Suspense fallback during lazy-chunk load AND as the in-component
  data-loading state — giving one consistent placeholder instead of the
  generic full-screen Loader skeleton. Reuses the real structural classes
  (.ins-grid / .ins-card / .ins-body …) and the shared .cd-skl shimmer.
*/
const InsuranceSkeleton = ({ cards = 6 }: { cards?: number }) => (
  <div className="page-content-wraper ins-page">
    <div className="ins-shell">
      {/* top bar */}
      <div className="ins-topbar">
        <div>
          <SkeletonBar w={130} h={20} />
          <SkeletonBar w={90} h={11} style={{ marginTop: 8 }} />
        </div>
        <div className="ins-actions">
          {[72, 150, 104, 78].map((w, i) => (
            <span className="cd-skl" style={{ width: w, height: 40, borderRadius: 9 }} key={i} />
          ))}
        </div>
      </div>

      {/* card grid */}
      <div className="ins-grid">
        {Array.from({ length: cards }).map((_, i) => (
          <div className="ins-card is-skeleton" key={i}>
            <div className="ins-chead">
              <div style={{ flex: 1, minWidth: 0 }}>
                <SkeletonBar w="78%" h={15} />
                <SkeletonBar w="52%" h={12} style={{ marginTop: 9 }} />
              </div>
            </div>
            <div className="ins-body">
              {Array.from({ length: 4 }).map((_, j) => (
                <div className="ins-row" key={j}>
                  <SkeletonBar w={78} h={11} />
                  <SkeletonBar w={96} h={11} />
                </div>
              ))}
            </div>
            <div className="ins-acts">
              {Array.from({ length: 3 }).map((_, k) => (
                <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} key={k} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default InsuranceSkeleton;
